/* eslint-disable @stripe-internal/embedded/no-restricted-globals */
function canAccessFrame(frame: Window) {
  try {
    // Accessing frame.name will result in a "Blocked a frame with origin "XXX" from accessing a cross-origin frame."
    const _ = frame.name;
    return true;
  } catch (e) {
    return false;
  }
}

export const getAccessibleFrames = (frame: Window = window): Window[] => {
  const {parent} = frame;
  if (frame === parent) {
    return [];
  }

  const parentFrames = window.parent.frames;
  const accessibleFrames = [];
  // We have to iterate using an index since map/foreach/for-in all throw exceptions outside the iterator
  for (let i = 0; i < parentFrames.length; i += 1) {
    const frame = parentFrames[i];
    if (canAccessFrame(frame)) {
      accessibleFrames.push(frame);
    }
  }

  return [...getAccessibleFrames(parent.parent), ...accessibleFrames];
};

export const getAccessoryLayer = (frameId: string): Window | null => {
  const accessibleFrames = getAccessibleFrames();
  return accessibleFrames.find((frame) => frame.name === frameId) || null;
};

export const getAllUILayers = (): Window[] => {
  return getAccessibleFrames().filter((frame) =>
    frame.name.startsWith('stripe-connect-ui-layer'),
  );
};

export const getDataLayerIframe = (connectInstanceId: string) => {
  const parentFrames = window.parent.frames;
  // We have to iterate using an index since map/foreach/for-in all throw exceptions outside the iterator
  for (let i = 0; i < parentFrames.length; i += 1) {
    const frame = parentFrames[i];
    try {
      if (frame.name === `connectjs_controller_${connectInstanceId}`) {
        return frame;
      }
    } catch (e) {
      if (!(e instanceof DOMException)) {
        throw e;
      }
    }
  }

  return null;
};
